module.exports = __webpack_public_path__ + "static/img/logo18.c729952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo18.jpg
// module id = BKn6
// module chunks = 1